var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("submit"),
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "" } },
                      [
                        _c("v-autocomplete", {
                          staticClass: "required_field",
                          attrs: {
                            "hide-details": "",
                            label: _vm.$t("vendor"),
                            items: _vm.warehouses,
                            "item-text": "warehouseName",
                            rules: [_vm.fieldIsRequired("warehouse")],
                            "return-object": ""
                          },
                          model: {
                            value: _vm.warehouse,
                            callback: function($$v) {
                              _vm.warehouse = $$v
                            },
                            expression: "warehouse"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "" } },
                      [
                        _c("v-autocomplete", {
                          staticClass: "required_field",
                          attrs: {
                            "hide-details": "",
                            label: _vm.$t("category"),
                            items: _vm.categories,
                            "item-text": "displayName",
                            rules: [_vm.fieldIsRequired("category")],
                            "item-value": "value"
                          },
                          model: {
                            value: _vm.localSupport.category,
                            callback: function($$v) {
                              _vm.$set(_vm.localSupport, "category", $$v)
                            },
                            expression: "localSupport.category"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.localSupport.category === "Inbound"
                  ? _c(
                      "v-layout",
                      { key: "inbound-" + _vm.localSupport.category },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm4: "" } },
                          [
                            _c("v-combobox", {
                              key: _vm.trackingsKey,
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("trackingNumbers"),
                                rules: [_vm.fieldIsRequired("trackings")],
                                chips: "",
                                multiple: "",
                                "deletable-chips": ""
                              },
                              model: {
                                value: _vm.localSupport.trackings,
                                callback: function($$v) {
                                  _vm.$set(_vm.localSupport, "trackings", $$v)
                                },
                                expression: "localSupport.trackings"
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.normalizedTrackingList(
                                _vm.localSupport.trackings
                              ),
                              function(tracking, index) {
                                return _c(
                                  "div",
                                  {
                                    key: "inbound-carrier-" + index,
                                    staticClass:
                                      "caption grey--text text--darken-1"
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(tracking) +
                                        " (" +
                                        _vm._s(_vm.$t("client")) +
                                        ": " +
                                        _vm._s(_vm.clientLabel(tracking)) +
                                        ")\n          "
                                    )
                                  ]
                                )
                              }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm4: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: "UPC",
                                rules: [_vm.fieldIsRequired("upc")]
                              },
                              model: {
                                value: _vm.localSupport.upc,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.localSupport,
                                    "upc",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "localSupport.upc"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm4: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("quantity"),
                                rules: [
                                  _vm.fieldIsRequired("quantity"),
                                  _vm.fieldIsInteger("quantity"),
                                  _vm.fieldIsNoLessThanZero("quantity")
                                ]
                              },
                              model: {
                                value: _vm.localSupport.quantity,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.localSupport,
                                    "quantity",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "localSupport.quantity"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.localSupport.category === "outbound"
                  ? _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs3: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("shipment id"),
                                rules: [_vm.fieldIsRequired("shipmentId")]
                              },
                              model: {
                                value: _vm.localSupport.shipmentId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.localSupport,
                                    "shipmentId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "localSupport.shipmentId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSingleTrackingCategory
                  ? _c(
                      "v-layout",
                      { key: "single-tracking-" + _vm.localSupport.category },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("trackingNumber"),
                                rules: [_vm.fieldIsRequired("trackingNumber")]
                              },
                              model: {
                                value: _vm.trackingInput,
                                callback: function($$v) {
                                  _vm.trackingInput =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "trackingInput"
                              }
                            }),
                            _vm._v(" "),
                            _vm.trackingInput
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "caption grey--text text--darken-1"
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("client")) +
                                        ": " +
                                        _vm._s(
                                          _vm.clientLabel(_vm.trackingInput)
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.localSupport.category === "RETURN_RESEND"
                  ? _c(
                      "v-layout",
                      {
                        key: "return-resend-" + _vm.localSupport.category,
                        attrs: { row: "", wrap: "" }
                      },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          _vm._l(_vm.resendPairsLocal, function(pair, index) {
                            return _c(
                              "v-layout",
                              {
                                key: "resend-pair-" + index,
                                attrs: { row: "", wrap: "", "align-end": "" }
                              },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm5: "", "pr-2": "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        "hide-details": "",
                                        label:
                                          _vm.$t("trackingNumber") + " (Old)",
                                        rules: [
                                          _vm.fieldIsRequired(
                                            "old tracking number"
                                          ),
                                          _vm.pairOldUniqueRule(index)
                                        ]
                                      },
                                      model: {
                                        value: pair.oldTracking,
                                        callback: function($$v) {
                                          _vm.$set(
                                            pair,
                                            "oldTracking",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "pair.oldTracking"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "caption grey--text text--darken-1"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("client")) +
                                            ": " +
                                            _vm._s(
                                              _vm.clientLabel(pair.oldTracking)
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm5: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        "hide-details": "",
                                        label:
                                          _vm.$t("trackingNumber") + " (New)",
                                        rules: [
                                          _vm.fieldIsRequired(
                                            "new tracking number"
                                          ),
                                          _vm.pairNewUniqueRule(index)
                                        ]
                                      },
                                      model: {
                                        value: pair.newTracking,
                                        callback: function($$v) {
                                          _vm.$set(
                                            pair,
                                            "newTracking",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "pair.newTracking"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "caption grey--text text--darken-1"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("client")) +
                                            ": " +
                                            _vm._s(
                                              _vm.clientLabel(pair.newTracking)
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "text-sm-right",
                                    attrs: { xs12: "", sm2: "" }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { small: "", icon: "" },
                                        on: { click: _vm.addResendPairRow }
                                      },
                                      [_c("v-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          icon: "",
                                          disabled:
                                            _vm.resendPairsLocal.length <= 1
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeResendPairRow(
                                              index
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("remove")])],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                [
                  "INTERCEPT_REASSIGN",
                  "RETURN_DESTROY",
                  "DOWNLOAD_POD"
                ].includes(_vm.localSupport.category)
                  ? _c(
                      "v-layout",
                      { key: "trackings-" + _vm.localSupport.category },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _c("v-combobox", {
                              key: _vm.trackingsKey,
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("trackingNumbers"),
                                rules: [_vm.fieldIsRequired("trackings")],
                                chips: "",
                                multiple: "",
                                "deletable-chips": ""
                              },
                              model: {
                                value: _vm.localSupport.trackings,
                                callback: function($$v) {
                                  _vm.$set(_vm.localSupport, "trackings", $$v)
                                },
                                expression: "localSupport.trackings"
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.normalizedTrackingList(
                                _vm.localSupport.trackings
                              ),
                              function(tracking, index) {
                                return _c(
                                  "div",
                                  {
                                    key: "tracking-carrier-" + index,
                                    staticClass:
                                      "caption grey--text text--darken-1"
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(tracking) +
                                        " (" +
                                        _vm._s(_vm.$t("client")) +
                                        ": " +
                                        _vm._s(_vm.clientLabel(tracking)) +
                                        ")\n          "
                                    )
                                  ]
                                )
                              }
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showEstimatedPrice
                  ? _c(
                      "v-layout",
                      { attrs: { "align-center": "" } },
                      [
                        _c(
                          "v-icon",
                          { staticStyle: { color: "deepskyblue" } },
                          [_vm._v("info")]
                        ),
                        _vm._v(" "),
                        _c("v-flex", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("estimatedPricePerItemWithTotal", {
                                  price: _vm.estimatedUnitPrice,
                                  total: _vm.estimatedPrice
                                })
                              ) +
                              "\n        "
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.localSupport.category === "labelClaim" ||
                _vm.localSupport.category === "labelChange"
                  ? _c(
                      "v-layout",
                      { key: "label-" + _vm.localSupport.category },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm6: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("trackingNumber"),
                                rules: [_vm.fieldIsRequired("trackingNumber")]
                              },
                              model: {
                                value: _vm.trackingInput,
                                callback: function($$v) {
                                  _vm.trackingInput =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "trackingInput"
                              }
                            }),
                            _vm._v(" "),
                            _vm.trackingInput
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "caption grey--text text--darken-1"
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("client")) +
                                        ": " +
                                        _vm._s(
                                          _vm.clientLabel(_vm.trackingInput)
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm6: "" } },
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                "hide-details": "",
                                label: _vm.$t("LabelID"),
                                rules: [_vm.fieldIsRequired("Label ID")]
                              },
                              model: {
                                value: _vm.localSupport.labelId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.localSupport,
                                    "labelId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "localSupport.labelId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("v-text-field", {
                  staticClass: "mb-2",
                  attrs: {
                    "hide-details": "",
                    label: _vm.$t("title"),
                    rules: [_vm.fieldIsRequired("title")]
                  },
                  model: {
                    value: _vm.localSupport.title,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.localSupport,
                        "title",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "localSupport.title"
                  }
                }),
                _vm._v(" "),
                _c("v-textarea", {
                  attrs: {
                    "hide-details": "",
                    outline: "",
                    label: _vm.$t("question"),
                    rules: [_vm.fieldIsRequired("question")],
                    counter: 500,
                    "auto-grow": "",
                    rows: "3"
                  },
                  model: {
                    value: _vm.localSupport.question,
                    callback: function($$v) {
                      _vm.$set(_vm.localSupport, "question", $$v)
                    },
                    expression: "localSupport.question"
                  }
                }),
                _vm._v(" "),
                _vm.localSupport.category === "Inbound"
                  ? _c(
                      "v-layout",
                      { attrs: { "align-center": "" } },
                      [
                        _c(
                          "v-icon",
                          { staticStyle: { color: "deepskyblue" } },
                          [_vm._v("info")]
                        ),
                        _c("v-flex", [
                          _vm._v(
                            "Proof of order with tracking number is required if the case is about missing package or wrong units in package"
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.localSupport.category === "Inbound"
                  ? _c(
                      "v-layout",
                      { attrs: { "align-center": "" } },
                      [
                        _c(
                          "v-icon",
                          { staticStyle: { color: "deepskyblue" } },
                          [_vm._v("info")]
                        ),
                        _c("v-flex", [
                          _vm._v(
                            "如果是要调查包裹丢失，或者是包裹里面的货物不对， 请上传带有跟踪号的下单截图或者其他详细证明"
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.warehouse.warehouseKey === "system" &&
                _vm.localSupport.category === "labelClaim"
                  ? [
                      _c(
                        "v-layout",
                        { attrs: { "align-center": "" } },
                        [
                          _c(
                            "v-icon",
                            { staticStyle: { color: "deepskyblue" } },
                            [_vm._v("info")]
                          ),
                          _c("v-flex", [
                            _vm._v(
                              "Please upload purchased invoice and package photos"
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { "align-center": "" } },
                        [
                          _c(
                            "v-icon",
                            { staticStyle: { color: "deepskyblue" } },
                            [_vm._v("info")]
                          ),
                          _c("v-flex", [_vm._v("请上传购买发票和包裹图片")])
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { xs12: "" } },
                  [
                    _vm.localSupport.category === "labelChange"
                      ? _c(
                          "v-layout",
                          { attrs: { "align-center": "" } },
                          [
                            _c(
                              "v-icon",
                              { staticStyle: { color: "deepskyblue" } },
                              [_vm._v("info")]
                            ),
                            _c("v-flex", [
                              _vm._v(_vm._s(_vm.$t("appliedAdditionalFee")))
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("UploadFileWidget", {
                      attrs: {
                        maxFiles: 5,
                        type: "supports",
                        sizeLimit: 5242880 * 4,
                        removeFilesUponUnmounted: _vm.removeFilesUponUnmounted
                      },
                      model: {
                        value: _vm.attachments,
                        callback: function($$v) {
                          _vm.attachments = $$v
                        },
                        expression: "attachments"
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b703bf9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b703bf9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupportEdit.vue
// module id = null
// module chunks = 